import { HlsPerformanceTiming, HlsProgressivePerformanceTiming, LoaderStats, LoadStats } from 'hls.js';

export class VbLoadStats implements LoaderStats {
	public aborted: boolean = false;
	public loaded: number = 0;
	public retry: number = 0;
	public total: number = 0;
	public chunkCount: number = 0;
	public bwEstimate: number = 0;
	public loading: HlsProgressivePerformanceTiming = { start: 0, first: 0, end: 0 };
	public parsing: HlsPerformanceTiming = { start: 0, end: 0 };
	public buffering: HlsProgressivePerformanceTiming = { start: 0, first: 0, end: 0 };
}
